import React, { createContext, useContext, useState, useEffect } from 'react';
import { auth, db } from './firebase';
import { 
  signInWithEmailAndPassword, 
  createUserWithEmailAndPassword, 
  signOut, 
  onAuthStateChanged 
} from 'firebase/auth';
import { doc, getDoc, setDoc } from 'firebase/firestore';

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [userRole, setUserRole] = useState(null);
  const [userClientId, setUserClientId] = useState(null);
  const [loading, setLoading] = useState(true);

  async function signup(email, password, userType, clientId) {
    const userCredential = await createUserWithEmailAndPassword(auth, email, password);
    const user = userCredential.user;
    
    // Store user role and clientId in Firestore using the correct field names
    await setDoc(doc(db, 'users', user.uid), {
      email: user.email,
      type: userType,
      clientid: clientId,
      uid: user.uid,
      createdAt: new Date()
    });
    
    return userCredential;
  }

  function login(email, password) {
    return signInWithEmailAndPassword(auth, email, password);
  }

  function logout() {
    setUserRole(null);
    setUserClientId(null);
    return signOut(auth);
  }

  async function fetchUserData(user) {
    if (user) {
      try {
        console.log('fetchUserData - user.uid:', user.uid);
        const userDoc = await getDoc(doc(db, 'users', user.uid));
        if (userDoc.exists()) {
          const userData = userDoc.data();
          console.log('fetchUserData - userData:', userData);
          // Use the correct field names from Firestore
          setUserRole(userData.type || userData.userType);
          setUserClientId(userData.clientid || userData.clientId);
        } else {
          // If no user document exists, create one with default values
          await setDoc(doc(db, 'users', user.uid), {
            email: user.email,
            type: 'user',
            clientid: '2ejjeh', // default client
            uid: user.uid,
            createdAt: new Date()
          });
          setUserRole('user');
          setUserClientId('2ejjeh');
        }
      } catch (error) {
        console.error('Error fetching user data:', error);
        setUserRole('user');
        setUserClientId('2ejjeh');
      }
    } else {
      setUserRole(null);
      setUserClientId(null);
    }
  }

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      setCurrentUser(user);
      await fetchUserData(user);
      setLoading(false);
    });

    return unsubscribe;
  }, []);

  const value = {
    currentUser,
    userRole,
    userClientId,
    login,
    signup,
    logout
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}
